/*
 * Elefanten Holz - product configurator enhancements  (PRODUCTION)
 * ----------------------------------------------------------------
 * Holz/Acryl material toggle + filtering, step numbering + selected value,
 * delivery estimate ("Lieferung vsl. <dates>", weekends skipped), sticky-bar
 * quantity sync, JUMP FIX (keep live picker + static liquid across re-render),
 * and per-option / per-product VARIANT DROPDOWN (window.__cfgDropdownOptions).
 */
(function () {
  'use strict';

  var CFG_DEBUG = false;

  function log() {
    if (!CFG_DEBUG || !window.console) return;
    var a = Array.prototype.slice.call(arguments);
    a.unshift('[cfg]');
    try { console.log.apply(console, a); } catch (e) {}
  }

  var CONFIG = {
    colorOptionNames: ['farbvarianten', 'farbe'],
    labelMap: { 'farbvarianten': 'Farbe' },
    materials: ['Holz', 'Acryl']
  };

  /* ---------- helpers ---------- */

  function accessibleName(el) {
    if (!el) return '';
    var sr = el.querySelector('.sr-only');
    return (el.getAttribute('aria-label') ||
            (sr && sr.textContent) ||
            el.getAttribute('data-tooltip') ||
            el.getAttribute('title') ||
            el.textContent || '').trim();
  }

  function materialOf(name) {
    for (var i = 0; i < CONFIG.materials.length; i++) {
      if (name.toLowerCase().indexOf(CONFIG.materials[i].toLowerCase() + ' ') === 0) {
        return CONFIG.materials[i];
      }
    }
    return '';
  }

  function optionPairs(wrap) {
    var pairs = [];
    Array.prototype.slice.call(wrap.children).forEach(function (node) {
      if (node.tagName === 'INPUT') {
        pairs.push({ input: node, label: null });
      } else if (pairs.length && !pairs[pairs.length - 1].label) {
        pairs[pairs.length - 1].label = node;
      } else {
        pairs.push({ input: node.querySelector('input') || null, label: node });
      }
    });
    return pairs;
  }

  function labelFor(wrap, input) {
    if (!input) return null;
    var byId = wrap.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(input.id) : input.id) + '"]');
    return byId || input.nextElementSibling || null;
  }

  /* ---------- material toggle ---------- */

  function buildMaterialToggle(fieldset) {
    var wrap = fieldset.querySelector('.variant-picker__option-values');
    if (!wrap) return;

    var pairs = optionPairs(wrap);
    var present = {};
    pairs.forEach(function (p) {
      var nameEl = p.label || p.input;
      var mat = materialOf(accessibleName(nameEl));
      if (p.input) p.input.setAttribute('data-material', mat);
      if (p.label) p.label.setAttribute('data-material', mat);
      if (mat) present[mat] = true;
    });

    var mats = CONFIG.materials.filter(function (m) { return present[m]; });
    if (mats.length < 2) return;

    var bar = document.createElement('div');
    bar.className = 'cfg-material';
    mats.forEach(function (m) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cfg-material__btn';
      b.textContent = m;
      b.setAttribute('data-material', m);
      b.addEventListener('click', function () {
        window.__cfgMaterial = m;
        selectMaterial(fieldset, m, true);
      });
      bar.appendChild(b);
    });
    wrap.parentNode.insertBefore(bar, wrap);

    var checked = wrap.querySelector('input:checked');
    var fromChecked = checked ? checked.getAttribute('data-material') : '';
    var initial = window.__cfgMaterial && mats.indexOf(window.__cfgMaterial) !== -1
      ? window.__cfgMaterial
      : (fromChecked || mats[0]);
    window.__cfgMaterial = initial;
    selectMaterial(fieldset, initial, false);
  }

  function selectMaterial(fieldset, material, doSelect) {
    fieldset.querySelectorAll('.cfg-material__btn').forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-material') === material);
    });

    var picker = fieldset.closest('variant-picker');
    if (picker) picker.setAttribute('data-material', material);
    window.__cfgMaterial = material;

    var wrap = fieldset.querySelector('.variant-picker__option-values');

    resyncMaterial(fieldset.closest('variant-picker') || document);

    if (!doSelect) return;

    var firstInput = null;
    optionPairs(wrap).forEach(function (p) {
      if (firstInput || !p.input) return;
      if (materialOf(accessibleName(p.label || p.input)) === material) firstInput = p.input;
    });
    if (!firstInput) return;

    var checked = wrap.querySelector('input:checked');
    var checkedMat = checked ? materialOf(accessibleName(labelFor(wrap, checked) || checked)) : '';
    if (checkedMat === material) return;

    firstInput.checked = true;
    firstInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* ---------- step numbering + relabel ---------- */

  function numberSteps(picker) {
    var root = picker.closest('.product') || document;
    var steps = root.querySelectorAll('.variant-picker__option, .cfg-personalization');
    var n = 1;
    steps.forEach(function (step) {
      var legend = step.querySelector('legend') ||
                   step.querySelector('.cfg-personalization__title');
      if (!legend) return;

      var valueSpan = legend.querySelector('span, .variant-picker__selected-value, [class*="selected"]');

      var base = legend.getAttribute('data-label');
      if (base === null) {
        var labelText = '';
        Array.prototype.forEach.call(legend.childNodes, function (node) {
          if (node.nodeType === 3) labelText += node.textContent;
        });
        base = labelText.replace(/^\s*\d+\.\s*/, '').trim();
        var key = base.replace(/:$/, '').trim().toLowerCase();
        if (CONFIG.labelMap[key]) base = CONFIG.labelMap[key] + (base.slice(-1) === ':' ? '' : ':');
        legend.setAttribute('data-label', base);
      }

      if (valueSpan) {
        while (legend.firstChild) legend.removeChild(legend.firstChild);
        legend.appendChild(document.createTextNode(n + '. ' + base + ' '));
        legend.appendChild(valueSpan);
      } else {
        legend.textContent = n + '. ' + base;
      }
      n++;
    });
  }

  function updateSelectedValues(scope) {
    (scope || document).querySelectorAll('.variant-picker__option').forEach(function (opt) {
      var legend = opt.querySelector('legend');
      if (!legend) return;
      var wrap = opt.querySelector('.variant-picker__option-values');
      if (!wrap) return;
      var checked = wrap.querySelector('input:checked');
      if (!checked) return;

      var lbl = labelFor(wrap, checked);
      var name = '';
      if (lbl) {
        name = (lbl.getAttribute('data-tooltip') ||
                lbl.getAttribute('title') ||
                (lbl.querySelector('.sr-only') && lbl.querySelector('.sr-only').textContent) ||
                lbl.textContent || '').trim();
      }
      if (!name) name = (checked.value || '').trim();
      if (!name) return;

      var span = null;
      var sib = legend.nextElementSibling;
      if (sib && sib.tagName === 'SPAN' &&
          !sib.classList.contains('sr-only') &&
          !/animated|plus|icon/i.test(sib.className || '')) {
        span = sib;
      }
      if (!span && legend.parentNode) {
        span = legend.parentNode.querySelector('.cfg-selected-value');
      }
      if (!span) {
        span = document.createElement('span');
        span.className = 'cfg-selected-value';
        legend.insertAdjacentElement('afterend', span);
      }

      span.textContent = name;

      if (legend.parentNode) {
        legend.parentNode.querySelectorAll('.cfg-selected-value').forEach(function (extra) {
          if (extra !== span) extra.parentNode.removeChild(extra);
        });
      }
    });
  }

  function enhancePicker(picker) {
    if (!picker.hasAttribute('data-cfg')) {
      picker.setAttribute('data-cfg', '1');
      picker.querySelectorAll('.variant-picker__option').forEach(function (fs) {
        var wrap = fs.querySelector('.variant-picker__option-values');
        if (!wrap) return;
        var present = {};
        wrap.querySelectorAll('.color-swatch, .block-swatch').forEach(function (l) {
          var mat = materialOf(accessibleName(l));
          if (mat) present[mat] = true;
        });
        var mats = CONFIG.materials.filter(function (m) { return present[m]; });
        if (mats.length >= 2) buildMaterialToggle(fs);

        var legend = fs.querySelector('legend');
        var key = legend ? legend.textContent.replace(/^\s*\d+\.\s*/, '').replace(/:$/, '').trim().toLowerCase() : '';
        if (legend && CONFIG.labelMap[key]) legend.textContent = CONFIG.labelMap[key] + ':';
      });
    }
    numberSteps(picker);
  }

  /* ---------- delivery estimate ---------- */

  function isWeekend(d) { var g = d.getDay(); return g === 0 || g === 6; }

  function addBusinessDays(date, days) {
    var d = new Date(date), added = 0;
    while (added < days) { d.setDate(d.getDate() + 1); if (!isWeekend(d)) added++; }
    return d;
  }

  function pad(n) { return String(n).padStart(2, '0'); }

  function deliveryRange(min, max) {
    var today = new Date();
    var start = addBusinessDays(today, Math.max(1, min));
    var end = addBusinessDays(today, Math.max(min, max));
    var sd = pad(start.getDate()) + '.' + pad(start.getMonth() + 1) + '.';
    var ed = pad(end.getDate()) + '.' + pad(end.getMonth() + 1) + '.';
    if (start.getFullYear() !== end.getFullYear()) {
      return sd + start.getFullYear() + '\u2013' + ed + end.getFullYear();
    }
    return sd + '\u2013' + ed + end.getFullYear();
  }

  function renderDelivery(scope) {
    (scope || document).querySelectorAll('.cfg-delivery').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 2;
      var max = parseInt(el.getAttribute('data-max'), 10) || 3;
      var t = el.querySelector('.cfg-delivery__text');
      if (t) t.textContent = 'Lieferung vsl. ' + deliveryRange(min, max);
      el.setAttribute('data-cfg-done', '1');
    });
  }

  /* ---------- sticky-bar quantity sync ---------- */

  function mainQtyInput() {
    return document.querySelector('quantity-selector input[name="quantity"], input[name="quantity"]:not(.cfg-sticky-qty__input)');
  }

  function bindStickyQty() {
    document.querySelectorAll('.cfg-sticky-qty').forEach(function (box) {
      if (box.hasAttribute('data-bound')) return;
      box.setAttribute('data-bound', '1');
      var val = box.querySelector('.cfg-sticky-qty__value');
      box.addEventListener('click', function (e) {
        var btn = e.target.closest('button'); if (!btn) return;
        var main = mainQtyInput(); if (!main) return;
        var q = parseInt(main.value, 10) || 1;
        q += parseInt(btn.getAttribute('data-step'), 10);
        if (q < 1) q = 1;
        main.value = q;
        main.dispatchEvent(new Event('change', { bubbles: true }));
        if (val) val.textContent = q;
      });
    });
  }

  /* ---------- optional personalization: drop empty properties ---------- */

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.querySelector) return;
    var emptied = [];
    form.querySelectorAll('.cfg-field input').forEach(function (i) {
      if (!i.value.trim() && !i.disabled) { i.disabled = true; emptied.push(i); }
    });
    setTimeout(function () { emptied.forEach(function (i) { i.disabled = false; }); }, 0);
  }, true);

  /* ---------- header layout ---------- */

  function arrangeHeader(scope) {
    scope = scope || document;

    scope.querySelectorAll('.product-info__block-item[data-block-type="text"]').forEach(function (b) {
      if (/mwst/i.test(b.textContent)) b.style.display = 'none';
    });

    scope.querySelectorAll('.product-sticky-bar__info').forEach(function (info) {
      var priceText = '';
      var priceBlock = document.querySelector('.product-info__block-item[data-block-type="price"]');
      if (priceBlock) {
        var el = priceBlock.querySelector('sale-price') ||
                 priceBlock.querySelector('.price-list__sale-price') ||
                 priceBlock.querySelector('.price-list > *:first-child');
        var raw = (el ? el.textContent : '').replace(/\s+/g, ' ');
        raw = raw.replace(/Angebot|Sonderpreis|Normaler Preis|Regul[\u00e4a]rer Preis/gi, '').trim();
        var m = raw.match(/[\u20ac$\u00a3]\s?\d[\d.,]*|\d[\d.,]*\s?[\u20ac$\u00a3]/);
        priceText = m ? m[0].trim() : raw;
      }

      var priceEl = info.querySelector('.cfg-sticky-price');
      if (!priceEl) {
        priceEl = document.createElement('span');
        priceEl.className = 'cfg-sticky-price';
        info.insertBefore(priceEl, info.firstChild);
      }
      if (priceText) priceEl.textContent = priceText;

      if (!info.querySelector('.cfg-sticky-mwst')) {
        var s = document.createElement('span');
        s.className = 'cfg-sticky-mwst';
        s.textContent = 'inkl. MwSt., zzgl. Versand';
        info.appendChild(s);
      }
    });
  }

  /* ---------- reliable selected-state for swatches ---------- */

  function markSelectedBlocks(scope) {
    (scope || document).querySelectorAll('.variant-picker__option-values').forEach(function (wrap) {
      var labels = wrap.querySelectorAll('.block-swatch, .color-swatch');
      if (!labels.length) return;
      labels.forEach(function (l) { l.classList.remove('cfg-active'); });
      var checked = wrap.querySelector('input:checked');
      if (!checked) return;
      var lbl = labelFor(wrap, checked);
      if (lbl && (lbl.classList.contains('block-swatch') || lbl.classList.contains('color-swatch'))) {
        lbl.classList.add('cfg-active');
      }
    });
  }

  /* ---------- material filter (inline display, split option only) ---------- */

  function resyncMaterial(scope) {
    scope = scope || document;
    var mat = window.__cfgMaterial;

    scope.querySelectorAll('.variant-picker__option').forEach(function (fs) {
      var wrap = fs.querySelector('.variant-picker__option-values');
      if (!wrap) return;

      var pairs = optionPairs(wrap);
      var present = {};
      pairs.forEach(function (p) {
        var nameEl = p.label || p.input;
        var m = materialOf(accessibleName(nameEl));
        p.__mat = m;
        if (m) present[m] = true;
      });

      var isSplit = present.Holz && present.Acryl;
      if (!isSplit) {
        pairs.forEach(function (p) {
          if (p.input) { p.input.classList.remove('cfg-hidden'); p.input.style.removeProperty('display'); }
          if (p.label) { p.label.classList.remove('cfg-hidden'); p.label.style.removeProperty('display'); }
        });
        return;
      }

      fs.querySelectorAll('.cfg-material__btn').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-material') === mat);
      });

      if (!mat) return;

      pairs.forEach(function (p) {
        var hide = p.__mat && p.__mat !== mat;
        [p.input, p.label].forEach(function (el) {
          if (!el) return;
          if (hide) { el.classList.add('cfg-hidden'); el.style.setProperty('display', 'none', 'important'); }
          else { el.classList.remove('cfg-hidden'); el.style.removeProperty('display'); }
        });
      });
    });
  }

  /* ---------- per-option variant DROPDOWN (per product) ----------
     Any option listed in window.__cfgDropdownOptions (comma-separated option
     labels, injected by Liquid from the product metafield custom.variant_dropdowns)
     is shown as a <select> instead of buttons. Real radios stay (hidden) so
     variant resolution, price, URL and the material filter keep working; the
     <select> mirrors them and re-syncs on every change. */

  function dropdownOptionNames() {
    var raw = window.__cfgDropdownOptions;
    if (!raw) return [];
    return String(raw).split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
  }

  function optionLegendName(fs) {
    var legend = fs.querySelector('legend');
    if (!legend) return '';
    var base = legend.getAttribute('data-label') || legend.textContent || '';
    return base.replace(/^\s*\d+\.\s*/, '').replace(/:$/, '').trim().toLowerCase();
  }

  function buildDropdownForOption(fs) {
    if (fs.__cfgDropdown) return;
    var wrap = fs.querySelector('.variant-picker__option-values');
    if (!wrap) return;

    var select = document.createElement('select');
    select.className = 'cfg-variant-select';

    select.addEventListener('change', function () {
      var input = document.getElementById(select.value);
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    var holder = document.createElement('div');
    holder.className = 'cfg-select-wrap cfg-variant-select-wrap';
    holder.appendChild(select);

    wrap.classList.add('cfg-values-hidden');
    wrap.parentNode.insertBefore(holder, wrap);

    fs.__cfgDropdown = { select: select, wrap: wrap };
  }

  function syncDropdowns(scope) {
    (scope || document).querySelectorAll('.variant-picker__option').forEach(function (fs) {
      var dd = fs.__cfgDropdown;
      if (!dd) return;
      var wrap = dd.wrap;
      var mat = window.__cfgMaterial;

      var checkedId = '';
      var checkedInput = wrap.querySelector('input:checked');
      if (checkedInput) checkedId = checkedInput.id;

      dd.select.innerHTML = '';
      optionPairs(wrap).forEach(function (p) {
        if (!p.input) return;
        var name = accessibleName(p.label || p.input) || p.input.value;
        var mm = materialOf(name);
        if (mat && mm && mm !== mat) return;
        var o = document.createElement('option');
        o.value = p.input.id;
        o.textContent = name;
        if (p.input.id === checkedId) o.selected = true;
        dd.select.appendChild(o);
      });

      if (dd.select.selectedIndex < 0 && dd.select.options.length) {
        dd.select.selectedIndex = 0;
        var first = document.getElementById(dd.select.value);
        if (first && !first.checked) {
          first.checked = true;
          first.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  function applyVariantDropdowns(picker) {
    var names = dropdownOptionNames();
    if (!names.length) return;
    picker.querySelectorAll('.variant-picker__option').forEach(function (fs) {
      var legendName = optionLegendName(fs);
      var match = names.some(function (n) { return legendName.indexOf(n) !== -1 || n.indexOf(legendName) !== -1; });
      if (match) buildDropdownForOption(fs);
    });
    syncDropdowns(picker);
  }

  /* ---------- run + observe ---------- */

  var target = document.querySelector('.product') || document.body;
  var scheduled = false;

  function enhanceAll() {
    document.querySelectorAll('variant-picker').forEach(enhancePicker);
    document.querySelectorAll('variant-picker').forEach(applyVariantDropdowns);
    resyncMaterial(document);
    syncDropdowns(document);
    arrangeHeader(document);
    markSelectedBlocks(document);
    updateSelectedValues(document);
    renderDelivery(document);
    bindStickyQty();
  }

  var observer = new MutationObserver(function () {
    var hasNewPicker = document.querySelector('variant-picker:not([data-cfg])');
    if (scheduled) return;
    if (!hasNewPicker &&
        !document.querySelector('.cfg-delivery:not([data-cfg-done])')) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      observer.disconnect();
      try { enhanceAll(); } finally { observer.observe(target, { childList: true, subtree: true }); }
    });
  });

  function run() {
    observer.disconnect();
    try { enhanceAll(); } finally { observer.observe(target, { childList: true, subtree: true }); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* ---------- JUMP FIX: keep our live picker + static liquid across re-render ---------- */
  document.addEventListener('product:rerender', function (e) {
    var d = e.detail || {};
    var frag = d.htmlFragment;
    if (!frag || !frag.querySelectorAll) return;
    if (d.productChange) return;
    frag.querySelectorAll('[data-block-type="variant-picker"], [data-block-type="liquid"]').forEach(function (b) {
      b.remove();
    });
  }, true);

  /* re-sync after a variant change (picker stays put) */
  document.addEventListener('change', function (e) {
    if (!(e.target && e.target.closest && e.target.closest('variant-picker'))) return;
    requestAnimationFrame(function () {
      resyncMaterial(document);
      syncDropdowns(document);
      markSelectedBlocks(document);
      updateSelectedValues(document);
      arrangeHeader(document);
    });
  }, true);
})();